export const appearanceContrastModes = [
  {
    id: "system",
    label: "System",
  },
  {
    id: "default",
    label: "Domyślny",
  },
  {
    id: "high-contrast",
    label: "Wysoki kontrast",
  },
  {
    id: "glass",
    label: "Szkło",
  },
];